import ListItem from "../ListItem/ListItem";
import "./NewsListSection.scss";
import {
  GridPresetOffsetWideContent,
  GridRow,
  InfoSmallIcon,
} from "/App.Components";
import { NewsListItemProps } from "/Models/Generated/NewsListItemProps";
import { NewsListSectionProps } from "/Models/Generated/NewsListSectionProps";

const NewsListSection: React.FC<NewsListSectionProps> = ({
  sectionHeading,
  items,
}) => {
  const getMetadataItems = (item: NewsListItemProps) => {
    return {
      firstRow: item.published && <InfoSmallIcon text={item.published} />,
    };
  };

  return (
    <div className="news-list-section-norad">
      <GridRow>
        <GridPresetOffsetWideContent>
          {sectionHeading && (
            <h2 className="news-list-section-norad__section-heading">
              {sectionHeading}
            </h2>
          )}
        </GridPresetOffsetWideContent>

        <ul className="news-list-section-norad__items">
          {items &&
            items.map((item, idx) => (
              <ListItem
                key={idx}
                metadataItems={getMetadataItems(item)}
                image={item.picture}
                heading={item.heading}
              />
            ))}
        </ul>
      </GridRow>
    </div>
  );
};

export default NewsListSection;
